define('presentation/settings/autoAttendant/presentationObjects/userGroupPresentationObject',[],function() {
    return function(){
        var self = this;

        self.userGroupId = null;
        self.groupName = null;
        self.avatar = null;
    };
});
